module.exports = __webpack_public_path__ + "static/img/video-call.56fc7f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video-call.jpg
// module id = Kzgn
// module chunks = 1